module.exports = __webpack_public_path__ + "img/document-upload.ad838f08.svg";